import * as React from 'react';
import { OUTPUT_DROPDOWN_DEFAULT } from '../../constants';
import { IBranch, IOperator, IConditionConfig, IQueryBuilderConfigRule, QueryBuilderHelper, EOutputLookupContext, DOMHelper } from '../../helpers';
import { QueryBuilder } from '../query-builder/query-builder';
import {
    TextField, Button, ButtonType, IDropdownOption, Label
} from 'office-ui-fabric-react';
import store from '../../store/store';

interface IProps {
    branch: IBranch;
    operators: IOperator[];
    operatorTypes: string[];
    outputOptions: IDropdownOption[];
    updateEditedBranch: (branch: IBranch) => void;
    saveEditedBranch: () => void;
    setBranchEditIndex: (branchEditIndex: number) => void;
    branchIndex?: number;
    componentId?: string;
    closeDialog?: (save?: boolean) => void;
    changeShowBranchEdit?: (val?: boolean) => void;
}

export class BranchEdit extends React.Component<IProps, any> {

    nameChange = (name: string) => {
        let { branch, updateEditedBranch } = this.props;
        branch.Name = name;
        updateEditedBranch(branch);
    }

    conditionConfigChange = (conditionConfig: IConditionConfig) => {
        let { branch, updateEditedBranch } = this.props;
        branch.ConditionConfig = conditionConfig;
        updateEditedBranch(branch);
    }

    public render() {

        let {
            branch, operators, operatorTypes, outputOptions,
            updateEditedBranch, saveEditedBranch, setBranchEditIndex, changeShowBranchEdit,
            branchIndex, componentId,
            closeDialog
        } = this.props;

        let operatorDropdownOptions: IDropdownOption[] = operators.map((v, i) => {
            let d: IDropdownOption = {
                key: v.Id,
                index: i,
                text: v.Name
            };
            return d;
        });

        //add blank option to the top of dropdownOptions
        let queryBuilderOutputOptions: IDropdownOption[] = [OUTPUT_DROPDOWN_DEFAULT];
        queryBuilderOutputOptions = queryBuilderOutputOptions.concat(outputOptions);

        return (

            (branchIndex >= 0) && (store.getState().modalState.decisionConfig.branchEditIndex === branchIndex) && (store.getState().modalState.decisionConfig.componentId === componentId) ?

                <div className="branch-edit-wrapper">

                    <QueryBuilder
                        queryBuilderConfig={branch.ConditionConfig}
                        propertyOptions={queryBuilderOutputOptions || []}
                        id={'branch_condition_editor' + '_' + branchIndex}
                        outputLookupContext={EOutputLookupContext.DecisionConfig}
                        onChange={this.conditionConfigChange}
                    />
                    <Button
                        className='branch-cancel-button'
                        buttonType={ButtonType.normal}
                        onClick={() => {
                            setBranchEditIndex(null);
                            closeDialog(false);
                        }}
                    >Cancel</Button>
                    <Button
                        className='branch-save-button'
                        buttonType={ButtonType.primary}
                        onClick={() => {
                            // if(QueryBuilderHelper.canSaveQueryEditor()) {
                            saveEditedBranch();
                            changeShowBranchEdit(false);
                            closeDialog(true);

                            // }
                        }}
                        onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}
                    >Save</Button>

                </div>
                :
                null
        );

    }
}



// WEBPACK FOOTER //
// ./source/ts/components/decisions/branch-edit.tsx